import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin, SpinProps } from 'antd';

function Spinner(props: SpinProps) {
  return (<Spin indicator={<LoadingOutlined spin />} {...props} />);
}

export default Spinner;
